import {useLocation, useNavigate, useParams} from "react-router";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";
import EncounterForm from "@/encounter/admin/form/EncounterForm.tsx";
import {useEncounterQuery, useSaveEncounterMutation} from "@/encounter/EncounterQueries.ts";
import type Encounter from "@/encounter/model/Encounter.ts";

export default function EncounterEditor({mode}: {mode: "create" | "edit"}) {
    const {id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {campaign, campaignPath} = useCampaign();
    const query = useEncounterQuery(mode === "edit" ? id : undefined);
    const save = useSaveEncounterMutation();

    if (mode === "edit" && query.isPending) return <DetailPaneState title="Encounter wird geladen…" loading/>;
    if (mode === "edit" && query.isError) return <DetailPaneState title="Encounter konnte nicht geladen werden" onRetry={() => void query.refetch()}/>;
    const encounter = mode === "edit" && query.data?.campaignId === campaign.id ? query.data : undefined;
    if (mode === "edit" && !encounter) return <DetailPaneState title="Encounter nicht verfügbar"/>;

    const onSubmit = async (updated: Encounter) => {
        await save.mutateAsync(updated);
        if (mode === "create") navigate({pathname: campaignPath(`encounters/${updated.id}`), search: location.search}, {replace: true});
    };
    const onCancel = () => navigate({
        pathname: campaignPath(encounter ? `encounters/${encounter.id}` : "encounters"),
        search: location.search,
    });

    return <>
        <title>{mode === "create" ? "Neuer Encounter | DireDawn" : `${encounter!.name} bearbeiten | DireDawn`}</title>
        <EncounterForm key={encounter?.id ?? "new"} encounter={encounter} onSubmit={onSubmit} onCancel={onCancel}/>
    </>;
}
